var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAeroplane6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8126 58.862C23.66 55.3524 27.1678 53.2091 30.6405 54.079L53.7803 59.6662L82.9307 31.1046L91.3551 33.1072L72.6741 64.1967L95.8734 69.7983L104.182 62.8964L110.51 64.4558L102.738 78.1289L103.4 93.9011L97.0206 92.4237L92.7464 82.3579L69.7256 76.7994L72.0512 113.056L63.6412 110.993L50.7354 72.2771L27.5956 66.6899C24.1905 65.9307 21.9344 62.2383 22.8126 58.862Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_839"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.7617,
    y: 143.6,
    width: 103.851,
    height: 103.851,
    rx: 51.9255,
    transform: "rotate(-121.426 54.7617 143.6)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroplane6);
export default __webpack_public_path__ + "static/media/aeroplane6.7c433e89f1dee4854d935d2f46f0d970.svg";
export { ForwardRef as ReactComponent };